<!-- 作品分类列表-->
<template>
<div id="book">
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">作品分类列表</div>
		
		<div style="display: flex;align-items: center;margin-top: 10px;margin-bottom: 15px;">
			<div v-for="(item,index) in titleTab" :key="index" 
			:class="{'title-tab-box-selected': item.select}" 
			@click="changeTab(item,index)"
			class="title-tab-box">{{item.label}}</div>
		</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;">
			
			<!-- <a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button> -->
			<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" icon="plus" type="primary">新建</a-button>
		</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" 
				@click="sortClick(0)" style="cursor: pointer;">
					ID
					<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
			
				<div v-if="(item.type !== 'id' && item.type !== 'book_name')" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
			</div>
			<!-- 频道 -->
			<div class="table-td-cell" :style="{'width': rableTitle[1].width + 'px'}">
				{{item.gender}}
			</div>
			<!-- 分类 -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
				{{item.category}}
			</div>
			<!-- 操作 -->
			<div @click="editTable(item,index)" class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" :style="{'width': table_scroll_width + 'px',}" style="text-align: center;padding: 80px 0 50px;">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 新增的侧边栏 -->
	<a-drawer
	  :title="`${drawer_title}分类`"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			
			
			<div class="form-cell-box">
				<div class="class-title">类型</div>
					
				<a-radio-group v-model="x_product_type" @change="radioChangeA">
				    <a-radio :value="1">
				        小说
				    </a-radio>
				    <a-radio :value="2">
				        短剧
				    </a-radio>
				</a-radio-group>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">频道</div>
					
				<a-select :value="x_book_type" style="width: 340px" placeholder="未选择"
				 @change="handleChangek" >
					<!-- <a-select-option value="0">待选择</a-select-option> -->
					<a-select-option value="1">男频</a-select-option>
					<a-select-option value="2">女频</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">分类名称</div>
					
				<a-input v-model="x_category" placeholder="请输入" style="width: 340px;"  />
			</div>
			
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>

	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putCategoryList, addBook, editBook, bookInfo, bookExport, putDataMenu, putCategoryAdd, putCategoryEdit } from '@/request/api'
export default {
	name: 'bookCategory_',
	components: {
	},
	data() {
		return {
			table_scroll_width: 2600,
			
			r_limit: 50,
			r_page: 1,
			r_sort_field: "gender",
			r_sort_type: "desc",
			r_product_type: 1, // 产品类型：1=小说，2=短剧
			r_book_category: undefined, // 作品分类
			r_channel_id: undefined, // 渠道
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:100, sort_status:0, type:"id", text_right: false,sort_:90,sort_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				
				{title:"频道",width:120, sort_status:0, type:"type", text_right: false,sort_:88,sort_control: false,},
				{title:"分类",width:150, sort_status:0, type:"category", text_right: false,sort_:87,sort_control: false,},
				
				{title:"操作",width:100, sort_status:0, type:"cz", text_right: false,sort_:85,sort_control: false,},
			],
			tableShowData: [],
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			// 新增侧边栏
			x_book_type: undefined, // 频道
			x_category: undefined, // 分类
			x_id: "", // id
			x_product_type: 1, // 产品类型：1=小说，2=短剧
			
			add_form_hint: "", // 侧边栏新增表单的验证提示
			categoryManList: [], // 男频的分类选择
			categoryWomanList: [], // 女频的分类选择
			categoryShowList: [], // 分类的显示
			drawer_title: "", // 侧边栏标题
			table_total: 0, // 表格内容总数
			
			body_width: 1800, // body的宽度
			
			// 筛选条件部分
			filterList: {
				channel_id:{
					list: [{}],
				},
				book_category: {},
			}, // 筛选条件数组
			
			titleTab: [
				{label: "小说分类", select: true , value: 1 },
				{label: "短剧分类", select: false , value: 2 },
			],
			content_type: 0, // 页面内容展现类型
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		// that.table_null_width = table_info.null_width
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterList = res.data.data.filter
		})
		
		that.searchButton()
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 新增侧边栏-频道
		handleChangek(value){
			console.log(value)
			
			if(value == 1){
				this.categoryShowList = this.categoryManList
			}
			else if(value == 2){
				this.categoryShowList = this.categoryWomanList
			}
			else {
				this.categoryShowList = []
			}
			this.x_book_type = value
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.r_page = 1
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				order: that.r_sort_field,
				sort: that.r_sort_type,
				
				channel_id: that.r_channel_id,
				product_type: that.r_product_type,
				book_category: that.r_book_category,
			}
			
			putCategoryList(r_data).then(res=>{
				console.log("搜索结果",res)
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.search_button_loading = false
					that.$message.success('搜索成功');
					
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data || []
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},100)
				}
				else {
					that.search_button_loading = false
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
			
			
		},

		// 新增侧边的确认按钮
		addRequest(){
			let that = this
			if(!that.x_category){ // 作品名称
				that.add_form_hint = "请填写 分类名称 ！！！"
			}
			else if(!that.x_book_type){ // 频道
				that.add_form_hint = "请填写 频道 ！！！"
			}
			else if(!that.x_category){ // 分类
				that.add_form_hint = "请填写 分类 ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					gender: that.x_book_type,
					category: that.x_category,
					
					product_type: that.x_product_type,
				}
				if(that.drawer_title == "新增"){
					putCategoryAdd(r_data).then(res=>{
						console.log("新增",res)
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('新增成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "新增失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					r_data.id = that.x_id
					// console.log(r_data)
					putCategoryEdit(r_data).then(res=>{
						console.log("编辑",res)
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.$message.success('编辑成功');
							that.add_button_loading = false
							// 关闭弹窗等一系列操作
							that.onCloseDrawer()
							// 重新搜索一边
							that.searchButton()
						}
						else {
							that.add_button_loading = false
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
				}
				
				
			}
		},
		onCloseDrawer(){
			// if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
			// 	return
			// }
			this.visible = false
			this.categoryShowList = []
			
			this.x_book_type = undefined, // 频道
			this.x_category = undefined // 分类
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = "gender"
				that.r_sort_type = "desc"
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		// 表格内的编辑
		editTdClick(item,index){
			let that = this
			console.log("item",item);
			
			that.x_id = item.id
			that.x_category = item.category
			if(item.product_type == "小说"){
				that.x_product_type = 1
			}
			else if(item.product_type == "短剧"){
				that.x_product_type = 2
			}
			if(item.gender == "男频"){
				that.x_book_type = "1"
			}
			else if(item.gender == "女频"){
				that.x_book_type = "2"
			}
			
			that.drawer_title = "编辑"
			
			that.visible = true
		},
		// 显示新增侧边栏
		addButton(){
			this.drawer_title = "新增"
			
			this.x_product_type = this.r_product_type
			
			this.visible = true
		},
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				this.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		editTable(index){
			// this.$emit('edit-td-click', index)
			this.editTdClick(index)
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				console.log("e.value",e.value);
				this.content_type = e.value
				this.r_product_type = e.value
				
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				
				this.searchButton('button')
			}
			console.log(this.content_type)
		},
		radioChangeA(e){
			this.x_product_type = e.target.value
			// this.x_product_type = this.r_product_type
			console.log("单选",e);
		},
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		}
	}
}
</script>

<style scoped>
/* 用于子页面的样式 */
.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}
</style>